import { render, staticRenderFns } from "./commentSet.vue?vue&type=template&id=2b25ea62&scoped=true&"
import script from "./commentSet.vue?vue&type=script&lang=js&"
export * from "./commentSet.vue?vue&type=script&lang=js&"
import style0 from "./commentSet.vue?vue&type=style&index=0&id=2b25ea62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b25ea62",
  null
  
)

export default component.exports